<template>
  <generic-modal :title="$t('account movement')" ref="generic_modal">
    <div>
      <div class="title is-5">
        <span class="icon"> <i class="fa fa-home"></i> </span>
        {{ neighbor.home_number }}
      </div>
      <div class="subtitle is-6">
        <span class="icon"> <i class="fa fa-user"></i> </span
        >{{ neighbor.resident_name }}
      </div>
      <div class="field">
        <generic-dropdown
          :title="$t('movement type')"
          :placeholder="$t('select one')"
          :is_multiple="false"
          url="/account/movement_type/catalog"
          name_field="name"
          value_field="movement_type_id"
          @selected="movement_type_changed"
          ref="momevement_type_dropdown"
        />
      </div>
      <div class="field">
        <label class="label">{{ $t("amount") }}</label>
        <div class="control has-icons-left has-icons-right">
          <input
            class="input"
            type="text"
            v-model="meta.amount"
            placeholder="100"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-money"></i>
          </span>
        </div>
      </div>
      <div class="field is-grouped is-grouped-multiline">
        <div class="control">
          <div
            class="tags are-medium has-addons"
            v-if="promotion && promotion.settings && promotion.settings.price"
          >
            <span class="tag is-dark">{{ $t("price") }}</span>
            <span class="tag is-info">{{
              format_currency(promotion.settings.price)
            }}</span>
          </div>
        </div>
        <div class="control">
          <div
            class="tags are-medium has-addons"
            v-if="
              promotion &&
              promotion.settings &&
              promotion.settings.months_to_add
            "
          >
            <span class="tag is-dark">{{
              promotion.settings.months_to_add
            }}</span>
            <span class="tag is-success">{{
              $t("extra membership months")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  format_currency,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "ChargeModal",
  components: { GenericModal, GenericCalendar, GenericDropdown },
  data() {
    return {
      neighbor: {},
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.movement_type_id ||
        !v.meta.amount ||
        !v.meta.account_id ||
        isNaN(v.meta.amount)
      );
    },
  },
  methods: {
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(neighbor) {
      let v = this;
      v.set_initial_state();
      get("/neighbor", { uuid: neighbor.uuid })
        .then((response) => {
          v.neighbor = response;
          // v.neighbor = neighbor;
          if (response.account) v.meta.account_id = response.account.account_id;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });

      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      put("/neighbor/account/movement", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.neighbor = {};
      v.meta = {
        account_id: "",
        amount: "",
        movement_type_id: "",
        settings: {},
      };
      v.error = "";
      v.$refs.momevement_type_dropdown.clear();
      // v.uuid = "";
    },
    movement_type_changed(movement_type) {
      console.log("movement_type_changed", movement_type);
      let v = this;
      if (movement_type) {
        v.movement_type = movement_type;
        v.meta.movement_type_id = movement_type.movement_type_id;
        if (movement_type.settings && movement_type.settings.default_amount)
          v.meta.amount = movement_type.settings.default_amount;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
